
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBubbleStyle } from '@/utils/types'
import BlockStyle from '@/components/common/flex-message/forms/BlockStyle.vue'

@Options({
  components: { BlockStyle },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Block extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubbleStyle

  @Prop()
  block!: string

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubbleStyle) {
    this.$emit('update:modelValue', value)
  }

  get title() {
    if (this.block === 'header') {
      return 'ヘッダー'
    } else if (this.block === 'hero') {
      return 'ヒーロー'
    } else if (this.block === 'body') {
      return 'ボディ'
    } else if (this.block === 'footer') {
      return 'フッター'
    }
    return ''
  }

  get subTitle() {
    if (this.block === 'header') {
      return 'ヘッダーのスタイル設定'
    } else if (this.block === 'hero') {
      return 'ヒーローのスタイル設定'
    } else if (this.block === 'body') {
      return 'ボディのスタイル設定'
    } else if (this.block === 'footer') {
      return 'フッターのスタイル設定'
    }
    return ''
  }
}
